import { autoinject, bindingMode } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { ComponentBase, IForm } from 'app/shared/lib/essette-site';
import { Toaster } from 'app/shared/lib/toaster';
import { apiCall } from 'app/shared/lib/essette-api';
import { FaxService } from 'app/fm/services/fax-service';
import { DocumentsService } from 'app/core/services/documents-service';
import { IDocumentsConfig } from 'app/core/models/essette-interfaces';
import * as FM from 'app/fm/models/essette-api';

@autoinject()
export class SaveFaxDocument extends ComponentBase implements IForm {

    ////****************** Fields and Properties ************************************////
    @bindable({ defaultBindingMode: bindingMode.toView })
    protected readonly faxDocumentId: string = "";

    @bindable({ defaultBindingMode: bindingMode.toView })
    protected readonly fileName: string = '';

    @bindable({ defaultBindingMode: bindingMode.twoWay })
    protected fileDisplayName: string = '';

    protected fileExtension: string = '';

    private ALTERED_FILE_NAME_MAX = 160;
    protected maxlength: number = this.ALTERED_FILE_NAME_MAX;

    // when false, Save button on component is disabled
    public nameChanged = false;

    protected documentsConfig: IDocumentsConfig = {
        serviceRootUrl: 'documents',
        targetType: 'Core.Document'
    };

    ////****************** Element References ***************************************////

    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly faxService: FaxService,
        private readonly documentService: DocumentsService,
        private readonly toaster: Toaster,
        ...rest: any[]) {
        super(...rest);
    }
    protected bind(bindingContext: Object, overrideContext: Object): void {
        this.documentService.configure(this.documentsConfig);
    }

    protected async fileNameChanged() {
        if(!this.fileName || this.fileName.length === 0) return;
        var sp = this.fileName.split('.');
        this.fileExtension = sp.pop()!;
        this.maxlength = this.ALTERED_FILE_NAME_MAX - this.fileExtension.length - 1;
        this.fileDisplayName = '';
        sp.forEach(s => {
            this.fileDisplayName += s + '.';
        });
        this.fileDisplayName = this.fileDisplayName.substring(0, this.fileDisplayName.length - 1);
    }


    ////****************** Functions ************************************************////
    public hasChanges(): boolean {
        return this.fileName != this.fileDisplayName + '.' + this.fileExtension;
    }


    ////****************** Events ***************************************************////
    protected fileDisplayNameChanged(): void {
        this.nameChanged = this.hasChanges();
    }

    public async submit(): Promise<boolean> {
        try {
            this.state.beginSave();
            const faxDocument: FM.FaxDocument = <any>{
                id: this.faxDocumentId,
                document: {
                    id: this.faxDocumentId,
                    file: {
                        name: this.fileDisplayName + '.' + this.fileExtension
                    }
                }
            };

            await this.saveFaxDocument(faxDocument);

            return true;
        }
        catch(error) {
            this.logger.error('Error Saving Document', error);
            return false;
        }
        finally {
            this.state.endSave();
        }
    }

    public reset(): void {
        this.faxService.checkInFaxDocument(this.faxDocumentId);
        this.fileNameChanged();
    }


    ////****************** Service Calls ********************************************////
    @apiCall
    private async saveFaxDocument(faxDocument: FM.FaxDocument): Promise<void> {
        try {
            this.state.beginSave();
            const response = await this.documentService.updateDocument(faxDocument.document!);
            this.toaster.standard.saved('fm:faxDocument.$long', response.isSuccessful);
        }
        catch(error) {
            this.toaster.standard.saved('fm:faxDocument.$long', false);
            throw error;
        }
        finally {
            this.state.endSave();
        }
    }

}
